import { schema } from './index'
import { toggleMark } from 'prosemirror-commands'
import { undo, redo } from 'prosemirror-history'

export function markActive(state, type) {
  const { from, $from, to, empty } = state.selection
  if (empty) {
    return type.isInSet(state.storedMarks || $from.marks())
  } else {
    return state.doc.rangeHasMark(from, to, type)
  }
}

export const menus = [{
  name: '加粗',
  value: 'strong',
  icon: 'bold',
  markType: schema.marks.strong,
  command: toggleMark(schema.marks.strong),
  enable: true,
}, {
  name: '斜体',
  value: 'italic',
  icon: 'italic',
  markType: schema.marks.em,
  command: toggleMark(schema.marks.em),
  enable: true,
}, {
  separator: true,
}, {
  name: '撤销',
  value: 'undo',
  icon: 'undo',
  enable(state) {
    return undo(state)
  },
  command: undo,
}, {
  name: '重做',
  value: 'redo',
  icon: 'redo',
  enable(state) {
    return redo(state)
  },
  command: redo,
}]
